import { CreditCard } from 'lucide-react'
import { ReportPageLayout, type ReportColumn, type SummaryStat } from './ReportPageLayout'
import { generateCreditBillingReport } from '@/src/lib/api/admin-reports'
import type { CreditBillingReportData } from '@/src/types/admin/reports'

const fmtN = (v: unknown) => Number(v ?? 0).toLocaleString('th-TH')
const fmt2 = (v: unknown) =>
  Number(v ?? 0).toLocaleString('th-TH', { minimumFractionDigits: 2 })

const columns: ReportColumn[] = [
  { key: 'month', label: 'เดือน' },
  { key: 'transaction_type', label: 'ประเภทธุรกรรม' },
  { key: 'count', label: 'จำนวนรายการ', format: fmtN },
  { key: 'total_amount', label: 'เครดิตรวม', format: fmtN },
]

function extractRows(data: unknown) {
  const d = data as CreditBillingReportData
  return (d?.monthly_breakdown ?? []) as unknown as Record<string, unknown>[]
}

function extractSummary(data: unknown): SummaryStat[] {
  const d = data as CreditBillingReportData
  const bal = d?.current_balance_summary
  if (!bal) return []
  return [
    { label: 'เครดิตคงเหลือรวม (ปัจจุบัน)', value: fmtN(bal.total_balance), description: 'ยอดเครดิตที่ยังไม่หมดอายุทั้งระบบ' },
    { label: 'จำนวนลูกค้า (ปัจจุบัน)', value: fmtN(bal.customer_count), description: 'ลูกค้าที่มีเครดิตคงเหลืออยู่ขณะนี้' },
    {
      label: 'เครดิตเฉลี่ยต่อลูกค้า',
      value: fmt2(bal.avg_balance),
      description: 'เฉลี่ยเครดิตคงเหลือต่อลูกค้า 1 ราย',
    },
  ]
}

export default function AdminReportCredits() {
  return (
    <ReportPageLayout
      title="รายงาน Credit & Billing"
      description="เครดิตที่ใช้, ซื้อ, หมดอายุ รายเดือน"
      audience="ผู้บริหาร"
      icon={CreditCard}
      columns={columns}
      fetchFn={generateCreditBillingReport}
      extractRows={extractRows}
      extractSummary={extractSummary}
      filenamePrefix="credit_billing"
    />
  )
}
